import { ArrowRight, GraduationCap, Luggage, MoonStar, Plane, Sparkles } from "lucide-react";
import { Eyebrow, IMAGES, Reveal } from "./shared";

const SERVICES = [
    {
        icon: Plane,
        title: "Visa Assistance",
        copy: "Guidance for eligible travel-related visa processes.",
    },
    {
        icon: GraduationCap,
        title: "Study Abroad",
        copy: "Support for students exploring international education.",
    },
    {
        icon: Sparkles,
        title: "Scholarships",
        copy: "Help discovering relevant scholarship opportunities.",
    },
    {
        icon: Luggage,
        title: "Tourism",
        copy: "Assistance with eligible tourist and visit travel planning.",
    },
    {
        icon: MoonStar,
        title: "Hajj & Umrah",
        copy: "Travel and pilgrimage assistance, handled with care.",
    },
];

export const GlobalMobility = () => (
    <section
        id="global-mobility"
        data-testid="global-mobility-section"
        className="bg-night py-24 text-ivory lg:py-32"
    >
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
            <div className="grid gap-10 lg:grid-cols-12 lg:items-end">
                <Reveal className="lg:col-span-8">
                    <Eyebrow dark>Global Mobility</Eyebrow>
                    <h2 className="mt-5 font-serif text-3xl font-medium tracking-tight sm:text-4xl lg:text-5xl">
                        Beyond Recruitment
                    </h2>
                    <p className="mt-6 max-w-xl text-base leading-relaxed text-ivory/65">
                        Supporting people and organizations as they navigate opportunities, education and
                        mobility across borders.
                    </p>
                </Reveal>
                <Reveal delay={0.1} className="lg:col-span-4 lg:text-right">
                    <a
                        href="#contact"
                        data-testid="mobility-explore-btn"
                        className="inline-flex items-center gap-2 border border-ivory/30 px-8 py-4 text-sm font-semibold uppercase tracking-[0.1em] text-ivory transition-colors hover:border-champagne hover:text-champagne"
                    >
                        Explore Global Mobility
                        <ArrowRight size={16} strokeWidth={1.5} />
                    </a>
                </Reveal>
            </div>

            <div className="mt-16 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
                {SERVICES.map((service, i) => (
                    <Reveal key={service.title} delay={i * 0.08}>
                        <div
                            data-testid={`mobility-${service.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                            className="border-t border-ivory/15 pt-7"
                        >
                            <service.icon size={26} strokeWidth={1.25} className="text-champagne" />
                            <h3 className="mt-5 font-serif text-2xl font-medium tracking-tight">
                                {service.title}
                            </h3>
                            <p className="mt-3 text-sm leading-relaxed text-ivory/60">{service.copy}</p>
                        </div>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.1} className="mt-16">
                <p
                    data-testid="mobility-disclaimer"
                    className="max-w-2xl border-l-2 border-champagne pl-5 text-xs leading-relaxed text-ivory/50"
                >
                    Visa and immigration decisions are made by the relevant authorities. Afrinexa Global does
                    not guarantee visa approval.
                </p>
            </Reveal>

            <Reveal delay={0.15} className="mt-14">
                <div className="group overflow-hidden">
                    <img
                        src={IMAGES.mobility}
                        alt="An airplane viewed through an international airport terminal window"
                        loading="lazy"
                        className="h-64 w-full object-cover opacity-90 transition-transform duration-[1200ms] ease-out group-hover:scale-105 lg:h-96"
                    />
                </div>
            </Reveal>
        </div>
    </section>
);
